import React from 'react';
import { useTranslation } from 'react-i18next';
import './NoResults.scss';

const NoResults = ({noResultsClear}) => {
  const { t } = useTranslation();
  return (
    <div className="no-results">
      <p>{t('roomRoster.noResultsLine1')}<strong>0</strong>{t('roomRoster.noResultsLine2')}
      </p>
      <div onClick={noResultsClear}>{t('roomRoster.clearSearch')}</div>
    </div>
  );
};

export default NoResults;

